import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

import {
  Box,
  Button,
  DialogContent,
  TextField,
  LinearProgress,
  Divider,
  Typography,
} from "@mui/material";
import {
  API_clone_bookings,
  API_clone_bookings_sample,
  API_delete_bookings_sample,
  API_get_bookings_sample,
} from "./utils/http";

import CopyAllRoundedIcon from "@mui/icons-material/CopyAllRounded";
import dayjs from "dayjs";
import { DataGrid } from "@mui/x-data-grid";
import {
  checkAdminRole,
  checkOper_or_admin,
  idToTimeYYYYMMD,
} from "./utils/tool";
import { COLUMN_BOOKING_SAMPLE, STATUS_CODE } from "./utils/constDispatch";
import { AlertCus } from "./components/AlertCus";
import AppBarSearchBox from "./components/SearchBox";
import { DialogCus } from "./components/DialogCus";
import InputLeft from "./InputLeft";
import OutputRight from "./components/pdf/OutputRight";
import NavbarSave from "./components/NavbarSave";

function AddBooking() {
  const [data, set_data] = useState(null);
  const [data_filter, set_data_filter] = useState(null);
  const [search_text, set_search_text] = useState("");
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const code = searchParams.get("code");

  const [open, setOpen] = useState(false);
  const [openSample, setopenSample] = useState(false);

  const [new_bookings, setNewBookings] = useState("");
  const [new_bookings_sample, setNewBookingsSample] = useState("");

  const [clone_ok, set_clone_ok] = useState(null);
  const [api_status, set_api_status] = useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open_status = Boolean(anchorEl);
  const [open1, setOpen1] = useState(false);

  const [filter_list, set_filter_list] = useState({
    proceeding: false,
    dealing: false,
    sample: true,
    done: false,
    date_from: null,
    date_to: null,
    all: false,
  });

  const handleClose = () => setAnchorEl(null);
  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClickOpen = () => setOpen(!open);
  const handleClickOpenSample = () => {
    setopenSample(!openSample);
  };
  const handleClickOpen1 = () => {
    setOpen1(!open1);
  };

  const confirmDelete = () => {
    handleClickOpen1();
    API_delete_bookings_sample(selected_id, (x) => {
      // set_delete_ok(x.success);
      if (x.success) {
        get_data_booking();
      }
      // else {
      //   set_delete_status(x.message);
      // }
    });
  };

  const get_data_booking = async () => {
    await API_get_bookings_sample((x) => {
      if (x.success) {
        let data = x.data;

        let x_new = [];
        data.map((item) => {
          item.created_at = idToTimeYYYYMMD(item._id);
          x_new.push(item);
        });
        x_new = x_new.reverse();
        set_data(x_new);

        x_new = apply_filters(x_new, filter_list);
        set_data_filter(x_new);
      }
    });
  };

  useEffect(() => {
    get_data_booking();
  }, []);

  const handle_search = (search_text) => {
    if (search_text == "") {
      set_data_filter(data);
    } else {
      let data_tmp = data.filter((x) => {
        let str =
          x.booking_number +
          x.customer_name +
          x.customer_email +
          x.customer_cell +
          x.package +
          x.day_start +
          x.created_by;

        str = str.replace(/\W/g, "").toLocaleLowerCase();
        let str_search = search_text.replace(/\W/g, "").toLocaleLowerCase();
        return str.includes(str_search);
      });

      set_data_filter(data_tmp);
    }
  };

  const [selected_id, set_selected_id] = useState(null);
  const [rowSelection, setRowSelection] = useState([]);

  useEffect(() => {
    if (code && data) {
      const row = data.find((r) => r.booking_number === code);
      if (row) {
        set_selected_id(row._id);
        setRowSelection([row._id]);
      }
    }
  }, [code, data]);

  const columns = COLUMN_BOOKING_SAMPLE.map((col) => {
    if (col.field === "booking_number") {
      return {
        ...col,
        renderCell: (params) => (
          <span
            onClick={() =>
              navigate(
                "/sample-booking?code=" + encodeURIComponent(params.value),
              )
            }
            style={{
              cursor: "pointer",
              color: "#1565C0",
              textDecoration: "underline",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
            }}
          >
            {params.value}
          </span>
        ),
      };
    }
    return col;
  });

  const apply_filters = (data, x_filter) => {
    if (x_filter.all) {
      return data;
    }

    let data_tmp = data.filter((x) => {
      if (x_filter.proceeding && x.status == STATUS_CODE.proceeding) {
        return true;
      } else if (x_filter.dealing && x.status == STATUS_CODE.dealing) {
        return true;
      } else if (x_filter.sample && x.status == STATUS_CODE.sample) {
        return true;
      } else if (x_filter.done && x.status == STATUS_CODE.done) {
        return true;
      } else if (
        !x_filter.proceeding &&
        !x_filter.dealing &&
        !x_filter.sample &&
        !x_filter.done &&
        x.status == null
      ) {
        return true;
      } else {
        return false;
      }
    });

    if (x_filter.date_from != null) {
      data_tmp = data_tmp.filter((x) => {
        return x_filter.date_from < dayjs(x.day_start, "DD/MM/YYYY");
      });
    }

    if (x_filter.date_to != null) {
      data_tmp = data_tmp.filter((x) => {
        return dayjs(x.day_start, "DD/MM/YYYY") < x_filter.date_to;
      });
    }
    return data_tmp;
  };

  const onClickCloneSample = () => {
    handleClickOpenSample();
    API_clone_bookings_sample(selected_id, new_bookings_sample, (e) => {
      console.log(e);
      set_clone_ok(e.success);
      if (e.success) {
        get_data_booking();
      } else {
        set_api_status(e.message);
      }
    });
  };

  const onClickClone = () => {
    handleClickOpen();
    API_clone_bookings(selected_id, new_bookings, (e) => {
      console.log(e);
      set_clone_ok(e.success);
      if (e.success) {
        get_data_booking();
      } else {
        set_api_status(e.message);
      }
    });
  };
  const [leftPanelWidth, setLeftPanelWidth] = useState(50); // percentage

  const open_details = Boolean(code && selected_id);

  if (code && !selected_id && data === null) {
    return (
      <Box sx={{ width: "100%", marginTop: 10 }}>
        <LinearProgress />
      </Box>
    );
  }

  if (code && !selected_id && data !== null) {
    return (
      <Box sx={{ width: "100%", marginTop: 10, textAlign: "center" }}>
        <Typography>Booking "{code}" not found</Typography>
      </Box>
    );
  }

  if (open_details) {
    return (
      <Box>
        <NavbarSave
          booking_id={selected_id}
          title={"Booking sample "}
          onGoBack={() => {
            navigate("/sample-booking");
            get_data_booking();
          }}
        />
        <Box
          style={{
            display: "flex",
            width: "100%",
            height: "calc(100vh - 64px)",
            overflow: "hidden",
          }}
        >
          <Box
            style={{
              width: `${leftPanelWidth}%`,
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <InputLeft
              booking_id={selected_id}
              onExitClick={() => {
                setOpenDetail(false);
                get_data_booking();
              }}
            />
          </Box>

          <Box
            style={{
              width: "8px",
              cursor: "col-resize",
              backgroundColor: "#e0e0e0",
              height: "100%",
              position: "relative",
              userSelect: "none",
              touchAction: "none",
              flexShrink: 0,
              zIndex: 10,
            }}
            // onMouseDown={startResize}
          >
            <div
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "4px",
                height: "30px",
                backgroundColor: "#bdbdbd",
                borderRadius: "2px",
              }}
            />
          </Box>

          <Box
            style={{
              width: `${100 - leftPanelWidth - 0.5}%`,
              height: "100%",
              overflow: "hidden",
              position: "relative",
            }}
          >
            <OutputRight booking_id={selected_id} />
          </Box>
        </Box>
      </Box>
    );
  } else {
    return (
      <Box>
        <AlertCus
          condition={clone_ok}
          message="Clone"
          additon_mess={api_status}
        />

        <AppBarSearchBox
          title="Sample Booking"
          value={search_text}
          onChange={(e) => {
            if (e.target.value == "") {
              handle_search("");
              set_selected_id(null);
            }
            set_search_text(e.target.value);
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handle_search(search_text);
              set_selected_id(null);
            }
          }}
        />

        {data_filter != null ? (
          <Box style={{ padding: "16px 20px" }}>
            <Box
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                gap: 10,
                marginBottom: 16,
              }}
            >
              {checkOper_or_admin() ? (
                <Button
                  size="small"
                  disabled={selected_id == null}
                  variant="outlined"
                  endIcon={<CopyAllRoundedIcon sx={{ fontSize: 16 }} />}
                  sx={{
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: 13,
                  }}
                  onClick={() => handleClickOpenSample()}
                >
                  Clone sample
                </Button>
              ) : null}
              <Button
                size="small"
                disabled={selected_id == null}
                variant="contained"
                endIcon={<CopyAllRoundedIcon sx={{ fontSize: 16 }} />}
                sx={{
                  borderRadius: "20px",
                  textTransform: "none",
                  fontWeight: 500,
                  fontSize: 13,
                }}
                onClick={() => handleClickOpen()}
              >
                Clone booking
              </Button>

              {checkAdminRole() ? (
                <Button
                  size="small"
                  variant="outlined"
                  disabled={selected_id == null}
                  color="error"
                  sx={{
                    borderRadius: "20px",
                    textTransform: "none",
                    fontWeight: 500,
                    fontSize: 13,
                  }}
                  onClick={() => handleClickOpen1()}
                >
                  Delete
                </Button>
              ) : null}
            </Box>

            <DialogCus
              open={openSample}
              title="Clone New Sample"
              handleClickOpen={handleClickOpenSample}
              handleClickConfirm={onClickCloneSample}
            >
              <DialogContent>
                <TextField
                  autoFocus
                  value={new_bookings_sample}
                  onChange={(e) => setNewBookingsSample(e.target.value)}
                  margin="dense"
                  id="name"
                  label="sample booking number"
                  fullWidth
                  variant="standard"
                />
              </DialogContent>
            </DialogCus>

            <DialogCus
              open={open1}
              title="Confirm delete"
              handleClickOpen={handleClickOpen1}
              handleClickConfirm={confirmDelete}
            ></DialogCus>

            <DialogCus
              open={open}
              title="Clone"
              handleClickOpen={handleClickOpen}
              handleClickConfirm={onClickClone}
            >
              <DialogContent>
                <TextField
                  autoFocus
                  value={new_bookings}
                  onChange={(e) => setNewBookings(e.target.value)}
                  margin="dense"
                  id="name"
                  label="booking number"
                  fullWidth
                  variant="standard"
                />
              </DialogContent>
            </DialogCus>
            <Box
              sx={{
                height: "100%",
                width: "100%",
                "& .MuiDataGrid-root": {
                  border: "1px solid #E0E0E0",
                  borderRadius: "10px",
                  overflow: "hidden",
                  fontSize: 13,
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#F5F7FA",
                  fontSize: 13,
                  fontWeight: 600,
                  color: "#555",
                  borderBottom: "1px solid #E0E0E0",
                },
                "& .MuiDataGrid-row": {
                  "&:hover": {
                    backgroundColor: "#F8FBFF",
                  },
                  "&.Mui-selected": {
                    backgroundColor: "#EBF4FF",
                    "&:hover": {
                      backgroundColor: "#DDEEFF",
                    },
                  },
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #F0F0F0",
                  py: 1,
                },
                "& .MuiDataGrid-footerContainer": {
                  borderTop: "1px solid #E0E0E0",
                  backgroundColor: "#FAFAFA",
                },
              }}
            >
              <DataGrid
                getRowHeight={(params) => "auto"}
                density="compact"
                getRowId={(item) => item._id}
                rows={data_filter}
                columns={columns}
                initialState={{
                  pagination: { paginationModel: { pageSize: 20 } },
                }}
                pageSizeOptions={[5, 10, 20]}
                rowSelectionModel={rowSelection}
                onRowSelectionModelChange={(e) => {
                  setRowSelection(e);
                  set_selected_id(e[0]);
                }}
              />
            </Box>
          </Box>
        ) : (
          <Box sx={{ width: "100%", marginTop: 10 }}>
            <LinearProgress />
          </Box>
        )}
      </Box>
    );
  }
}

export default AddBooking;
